export const DRAGON_FRUIT = 'DRAGON_FRUIT';
export const STRAWBERRY = 'STRAWBERRY';
export const COCONUT = 'COCONUT';
export const DRAGON_FRUIT_CANCEL = 'DRAGON_FRUIT_CANCEL';



// WEBPACK FOOTER //
// ./app/constants/zendeskProjectTypes.js